var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeScanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".barcode-ico{opacity:0.8;}.barcode-item-ico{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "barcode-ico"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,2H2A2,2,0,0,0,0,4V6.5a.5.5,0,0,0,1,0V4A1,1,0,0,1,2,3H4.5a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.5V4a2,2,0,0,0-2-2H15.5a.5.5,0,0,0,0,1H18a1,1,0,0,1,1,1V6.5a.5.5,0,0,0,1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,18H18a2,2,0,0,0,2-2V13.5a.5.5,0,0,0-1,0V16a1,1,0,0,1-1,1H15.5a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.5V16a2,2,0,0,0,2,2H4.5a.5.5,0,0,0,0-1H2a1,1,0,0,1-1-1V13.5a.5.5,0,0,0-1,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 10,
    rx: 0.5,
    transform: "translate(3 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    rx: 0.5,
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 10,
    rx: 0.5,
    transform: "translate(8 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    rx: 0.5,
    transform: "translate(10 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 10,
    rx: 0.5,
    transform: "translate(16 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    rx: 0.5,
    transform: "translate(13 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "barcode-item-ico",
    width: 20,
    height: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeScanner);
export default __webpack_public_path__ + "static/media/BarcodeScanner.ac4d00a33a7d8be4a69ef9ff126fefe5.svg";
export { ForwardRef as ReactComponent };